import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { PortalLeaveSummaryResponse } from "@/actions/ssr/leave/portal/getPortalLeaveSummarySSR";
import type { PortalLeaveBalancesResponse } from "@/actions/ssr/leave/portal/getPortalLeaveBalancesSSR";
import type { PortalLeaveRequestsResponse } from "@/actions/ssr/leave/portal/getPortalLeaveRequestsSSR";

interface PortalLeaveState {
  summary: PortalLeaveSummaryResponse;
  balances: PortalLeaveBalancesResponse;
  requests: PortalLeaveRequestsResponse;
  requestsClientFetched: boolean;
}

const initialState: PortalLeaveState = {
  summary: {
    total_balance_days: 0,
    taken_days: 0,
    pending_count: 0,
    approved_days: 0,
  },
  balances: {
    total_allocation: 0,
    balances: [],
  },
  requests: [],
  requestsClientFetched: false,
};

const portalLeaveSlice = createSlice({
  name: "portalLeave",
  initialState,
  reducers: {
    setSummary(state, action: PayloadAction<PortalLeaveSummaryResponse>) {
      state.summary = action.payload;
    },
    setBalances(state, action: PayloadAction<PortalLeaveBalancesResponse>) {
      state.balances = action.payload;
    },
    setRequests(state, action: PayloadAction<PortalLeaveRequestsResponse>) {
      state.requestsClientFetched = true;
      state.requests = action.payload;
    },
    setRequestsFromSSR(
      state,
      action: PayloadAction<PortalLeaveRequestsResponse>,
    ) {
      if (state.requestsClientFetched) return;
      state.requests = action.payload;
    },
  },
});

export const { setSummary, setBalances, setRequests, setRequestsFromSSR } =
  portalLeaveSlice.actions;
export default portalLeaveSlice.reducer;
